import { TSurveyModel } from "@performyard/models";

import { getDateCell, getEmployeeNameCell, getSurveyNameCell } from "./components/CellRenderers";

import { getStatusChip } from "../../utils";

type SurveysConfig = {
	navLinks: {
		key: string;
		label: string;
		href: string;
	}[];
	allSurveysStaticTableCols: {
		id: string;
		label: string;
		width: number;
		getter: (row: TSurveyModel) => React.ReactNode | null;
	}[];
};

// surveys UI constants
export const SURVEYS_TABLE_LIMIT = 25;

// surveys UI config
export const surveysConfig: SurveysConfig = {
	navLinks: [{ key: "all-surveys", label: "All Surveys", href: "/surveys" }],
	allSurveysStaticTableCols: [
		{
			id: "name",
			label: "Survey Name",
			width: 400,
			getter: (row: TSurveyModel) => {
				return getSurveyNameCell(row);
			},
		},
		{
			id: "status",
			label: "Status",
			width: 120,
			getter: (row: TSurveyModel) => {
				return getStatusChip(row.status);
			},
		},
		{
			id: "start_date",
			label: "Start Date",
			width: 140,
			getter: (row: TSurveyModel) => {
				return getDateCell(row.startDate ?? null);
			},
		},
		{
			id: "end_date",
			label: "End Date",
			width: 140,
			getter: (row: TSurveyModel) => {
				return getDateCell(row.endDate ?? null);
			},
		},
		{
			id: "created_by",
			label: "Created By",
			width: 148,
			getter: (row: TSurveyModel) => {
				return getEmployeeNameCell({ _id: row.createdBy?.toString() ?? "", name: row.createdByName ?? "" });
			},
		},
	],
};

export const getSurveysNavLinks = (permissions: string[]) => {
	const links: { key: string; label: string; href: string }[] = [];

	if (permissions.includes("surveys:view")) {
		links.push({
			key: "all-surveys",
			label: "All Surveys",
			href: "/surveys",
		});
	}
	links.push({
		key: "my-surveys",
		label: "My Surveys",
		href: "/surveys/my-surveys",
	});
	if (permissions.includes("surveys:viewDirectReportSurveys")) {
		links.push({
			key: "my-teams-surveys",
			label: "My Team's Surveys",
			href: "/surveys/my-teams-surveys",
		});
	}

	return links;
};
